export default __webpack_public_path__ + "static/char-thumb-58-1ea6e2982c69ad94ad72b49ddc43a5c6.png";